export const RESPONDER_FAILURE_KINDS = {
  AnswerNotProcessed: 'answerNotProcessed',
  InsightNotFound: 'insightNotFound',
  JumpNotAllowed: 'jumpNotAllowed',
  ProjectNotPublished: 'projectNotPublished',
  ProjectNotUnified: 'projectNotUnified',
  QuestionRequired: 'questionRequired',
  QuestionUnavailable: 'questionUnavailable',
  ResponseLimitReached: 'responseLimitReached',
  ScreenerRequired: 'screenerRequired',
  SelectionBoundsViolated: 'selectionBoundsViolated',
  SessionExpired: 'sessionExpired',
  SessionUnrecoverable: 'sessionUnrecoverable',
} as const;

export type ResponderFailureKind =
  (typeof RESPONDER_FAILURE_KINDS)[keyof typeof RESPONDER_FAILURE_KINDS];

export const RESPONDER_FAILURE_KIND_VALUES: readonly ResponderFailureKind[] =
  Object.values(RESPONDER_FAILURE_KINDS);

export const QUESTION_ALREADY_COMPLETED_FAILURE = 'questionAlreadyCompleted';
